import {Inject, Injectable} from '@angular/core';
import { SecureApi } from '../../core/secure.api';
import { KlenicoMeService } from '../me.service';
import { AppService } from '../../app.service';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class ProfileService extends KlenicoMeService{
    patientId = 0;
    token = '';
    COMPONENT = '';
    constructor(
        public secureApi: SecureApi,
        public appService: AppService,
        public translateService: TranslateService,
        public http : HttpClient,
        @Inject('storyBlokToken') public storyBlokToken: string,
        @Inject('storyBlokAPI') public storyBlokAPI: string,
    ) {
        super(secureApi, appService, translateService, http, storyBlokToken, storyBlokAPI);
        this.COMPONENT
    }

    getProfile(id) {
        return this.secureApi.get('b2c-patients/profile/' + id);
    }

    updateProfile(data) {
        return this.secureApi.post('b2c-patients/update-profile/' + this.patientId, data, false);
    }

    getProfileBillingAddress() {
        return this.secureApi.get('b2c-payments/billing-address');
    }

    sendVerification(data) {
        return this.secureApi.post('b2c-patients/resend-verify-mail/', data, false);
    }

    deleteProfile(url) {
        return this.secureApi.delete(url + '/' + this.patientId);
    }

}
